
define('ldsh!modules/page_listing/templates/search_tagcloud', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<div class="ed-tag-cloud-wrapper js-tags"></div>\n<button class="ed-btn ed-search-btn js-button-tagcloud"><i class="ed-icon ed-icon-search"></i> <span class="txt" data-i18n="pageListing.search.search">Buscar</span> </button>';

}
return __p
};});

